import script from "./ClientPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientPage.vue?vue&type=script&setup=true&lang=ts"

import "./ClientPage.vue?vue&type=style&index=0&id=84e6b858&lang=scss"

const __exports__ = script;

export default __exports__